import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" fill="#0B0B0B" />
    <path d="M24 7C24 7 12.5 20.5 12.5 28a11.5 11.5 0 0 0 23 0C35.5 20.5 24 7 24 7Z" fill="#FF5A00" />
    <path d="M7 34.5q4.25-4.5 8.5 0t8.5 0 8.5 0 8.5 0" stroke="#FFC400" strokeWidth="3.2" fill="none" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="logo-home-link" className="group flex items-center gap-3">
    <LogoMark className="h-10 w-10 transition-transform duration-500 group-hover:rotate-[8deg]" />
    <span className="leading-none">
      <span className={`font-wide block text-[15px] font-black tracking-tight ${light ? "text-white" : "text-[#0B0B0B]"}`}>
        TIDE INCHEM
      </span>
      <span className={`mt-1 block font-mono text-[10px] uppercase tracking-[0.2em] ${light ? "text-zinc-400" : "text-zinc-600"}`}>
        Printing Inks · 1997
      </span>
    </span>
  </Link>
);
